var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"warning-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24px","viewBox":"0 0 24 24","width":"24px"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }